import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import usePageStore from '../Page/pageStore';
import useDataStore from '../Data/dataStore';
import { applyMetadata, buildMetadata } from './metaUtils';
/**
 * Keeps the document head in step with the page being shown. Renders nothing;
 * it lives inside the router so it can read the pathname for the canonical and
 * og:url, the way Router and WordpressDispatcher do.
 */
const PageMetadata = () => {
    const activePage = usePageStore((state) => state.activePage);
    const content = useDataStore((state) => state.data[activePage]);
    const pathname = useLocation().pathname;
    useEffect(() => {
        applyMetadata(buildMetadata(content, pathname));
    }, [content, pathname]);
    return null;
};
export default PageMetadata;
